module.exports = __webpack_public_path__ + "media/images/pages/img_culture_area_02-db526c99c4afad2ca1b64ad47a629411.jpg";